
import { GridColumns } from '@mui/x-data-grid-pro'
import { HotLabEquipmentDto } from '@services/dtos'
import { useEffect, useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import { getHotLabEquipments, removeHotLabEquipment, setHotLabEquipmentFilters, updateHotLabEquipment } from '@state/reducers/hotLabEquipmentReducer'
import { HotLabEquipmentTypeLabels } from '@utils/constants'
import HotLabEquipmentForm from '../forms/HotLabEquipmentForm'
import moment from 'moment'

export default function HotLabEquipmentsTable() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setHotLabEquipmentFilters({ includeInactive: false }))
    }
  }, [])
    
  const columns: GridColumns<HotLabEquipmentDto> = useMemo(
    () => [
      { field: 'name', headerName: 'Nom', width: 200 },
      { field: 'type', headerName: 'Type', width: 150, valueGetter: (params) => HotLabEquipmentTypeLabels[params.row.type] },
      { field: 'serial', headerName: 'Série', width: 200 },
      { field: 'manufacturer', headerName: 'Fabricant', width: 200 },
      { field: 'model', headerName: 'Modèle', width: 200 },
      {
        field: 'installedAt',
        headerName: 'Date d\'installation',
        width: 200,
        valueGetter: (params) => params.row.installedAt ? moment(params.row.installedAt).format('DD/MM/YYYY') : ''
      },
      { field: 'location', headerName: 'Emplacement', width: 200 },
      { field: 'notes', headerName: 'Notes', width: 300 },
      {
        field: 'storageLocations',
        headerName: 'Stockages',
        width: 300,
        valueGetter: (params) => params.row.storageLocations?.map(loc => loc.name).join(', ')
      },
      { field: 'hasPeriodicQualityChecks', headerName: 'Contrôles qualité périodiques', width: 180, type: 'boolean' },
      { field: 'internalCheckIntervalDays', headerName: 'Périodicité interne (j)', width: 170, type: 'number' },
      { field: 'externalCheckIntervalDays', headerName: 'Périodicité externe (j)', width: 170, type: 'number' },
      {
        field: 'externalOrganization',
        headerName: 'Organisme externe',
        width: 200,
        valueGetter: (params) => params.row.externalOrganization?.name || ''
      },
    ],
    [],
  )

  return (
    <BaseConfigTable<HotLabEquipmentDto>
      columns={columns}
      selectRows={(state) => state.hotLabEquipment.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setHotLabEquipmentFilters({ includeInactive: true }))
        return dispatch(getHotLabEquipments())
      }}
      deleteThunk={removeHotLabEquipment}
      toggleThunk={(id, isActive) => updateHotLabEquipment({ id, dto: { isActive } })}
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setHotLabEquipmentFilters({ page }))
        dispatch(getHotLabEquipments())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <HotLabEquipmentForm editingHotLabEquipment={editingItem} onClose={onClose} />
      )}
      resourceLabel="matériel de laboratoire"
      resourcePrefix="le "
      formMaxWidth='md'
    />
  )
}
